import { Navigate, useParams } from 'react-router-dom';
import { ROUTES } from '@/models/router.model';
import { ContentPageEditorContainer } from '@/modules/ContentPages';

const ContentPageEditor = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  if (!id) {
    return <Navigate to={ROUTES.CONTENT_PAGE_EXAMPLE} replace />;
  }
  return <ContentPageEditorContainer />;
};

export default ContentPageEditor;
